"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const user_1 = require("@completeanatomy/user");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const styled_components_1 = __importDefault(require("styled-components"));
const email_1 = require("../../../service/utils/email");
const atoms_1 = require("../../atoms");
const InviteByEmailButton_1 = __importDefault(require("../../atoms/InviteByEmailButton"));
function GroupEditMembersSearch({ users, className, onSearch, onSelect, isLoading, setIsLoading, }) {
    const [state, setState] = (0, react_1.useState)('');
    const [showAutocompleteList, setShowAutocompleteList] = (0, react_1.useState)(false);
    const { t } = (0, react_i18next_1.useTranslation)();
    const currentUser = (0, user_1.useUser)();
    const onChange = (searchValue) => {
        setIsLoading(true);
        onSearch(searchValue);
        setState(searchValue);
    };
    const toShowInviteButton = state &&
        !isLoading &&
        !users.length &&
        (0, email_1.isEmailValid)(state) &&
        (currentUser === null || currentUser === void 0 ? void 0 : currentUser.email) !== state;
    (0, react_1.useEffect)(() => {
        setShowAutocompleteList(users.length > 0 && !isLoading);
    }, [isLoading, users]);
    const onSelectItem = (user) => {
        setShowAutocompleteList(false);
        if (user) {
            onSelect(user);
            onChange('');
        }
    };
    const onInviteByEmail = () => {
        onSelect({ label: state, identifier: -1 });
        onChange('');
    };
    return ((0, jsx_runtime_1.jsxs)(Container, { className: className, "data-e2e": 'GroupEditMembersSearch_Container', children: [(0, jsx_runtime_1.jsx)(IconContainer, { "data-e2e": 'GroupEditMembersSearch_IconContainer', children: (0, jsx_runtime_1.jsx)(FieldIcon, { name: ui_1.Icons.Cross, "data-e2e": 'GroupEditMembersSearch_FieldIcon' }) }), (0, jsx_runtime_1.jsxs)(FieldContainer, { "data-e2e": 'GroupEditMembersSearch_FieldContainer', children: [(0, jsx_runtime_1.jsx)(FieldInput, { value: state, placeholder: t(i18n_1.Strings.groups.edit.members.placeholder), onChange: onChange, "data-e2e": 'GroupEditMembersSearch_FieldInput' }), (0, jsx_runtime_1.jsx)(SpinnerContainer, { "$isVisible": isLoading, "data-e2e": 'GroupEditMembersSearch_SpinnerContainer', children: (0, jsx_runtime_1.jsx)(atoms_1.Spinner, { "data-e2e": 'GroupEditMembersSearch_Spinner' }) }), toShowInviteButton && ((0, jsx_runtime_1.jsx)(InviteByEmailButton_1.default, { onInvite: onInviteByEmail, "data-e2e": 'GroupEditMembersSearch_InviteByEmailButton' }))] }), showAutocompleteList && ((0, jsx_runtime_1.jsx)(ui_1.Autocomplete, { items: users, onSelect: onSelectItem, "data-e2e": 'GroupEditMembersSearch_Autocomplete' }))] }));
}
exports.default = GroupEditMembersSearch;
const Container = styled_components_1.default.div `
  position: relative;

  display: flex;
`;
const IconContainer = styled_components_1.default.div `
  display: flex;
  flex-shrink: 0;

  width: 35px;
  height: 35px;

  margin: 0 10px 0 0;

  background: ${props => props.theme.green};

  border-radius: 50%;
`;
const FieldIcon = (0, styled_components_1.default)(ui_1.Icon) `
  width: 12px;
  height: 12px;

  margin: auto;

  color: ${props => props.theme.text};

  transform: rotate(45deg);
`;
const FieldInput = (0, styled_components_1.default)(ui_1.Input) `
  width: 100%;
  font-size: 14px;

  &:focus {
    outline: none;
  }
`;
const FieldContainer = styled_components_1.default.div `
  border-bottom: 1px solid ${props => props.theme.fieldBorder};
  display: flex;
  width: 100%;
`;
const SpinnerContainer = styled_components_1.default.div `
  display: ${({ $isVisible }) => ($isVisible ? 'block' : 'none')};

  position: absolute;
  right: 0;
  top: 5px;
`;
